export const PRODUCT_COLORS = {
  facturacion:'#3b82f6', OTC:'#a855f7', terminales:'#f97316',
  'links de pago':'#06b6d4', wallet:'#22c55e', software:'#6366f1', Telefonica:'#ef4444',
};

export const TABS = [
  { id: 'todos',      label: 'Todos' },
  { id: 'facturacion',label: 'Facturación' },
  { id: 'otc',        label: 'OTC' },
  { id: 'terminales', label: 'Terminales' },
  { id: 'links_pago', label: 'Links de pago' },
  { id: 'wallet',     label: 'Wallet' },
  { id: 'software',   label: 'Software' },
  { id: 'telefonica', label: 'Telefónica' },
];
